import { Component, OnInit } from '@angular/core';
import { BaMenuService } from '../theme';
import { Routes } from '@angular/router';
import { ADMIN_MENU } from './admin.menu';
@Component({
    selector: 'alps-admin',
    template: require('./admin.component.html'),
    styles: [require('./admin.component.css')]
})
export class AdminComponent implements OnInit {

    constructor(private _menuService: BaMenuService) { }

    ngOnInit() {
        this._menuService.updateMenuByRoutes(<Routes>ADMIN_MENU);
    }
    public notificationOptions = {
        position: ["bottom", "right"],
        timeOut: 3000,
        lastOnBottom: true
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin.component.ts